import { Typography } from "@mui/material";
import React, { useEffect } from "react";
import "aos/dist/aos.css";
import { convertImagePathToUrl } from "../../utils";
import GrayArrowRight from "../../assets/images/GrayArrowRight.png";

export const TeamLoop2 = ({ Loop2, showTrendGenZHeading }) => {
  const formatModalDescription = (description) =>
    description?.replace(/(\r\n|\r|\n)/g, "<br>");

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll(".aos-init");

      elements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const triggerPoint = window.innerHeight / 2;

        if (rect.top < triggerPoint) {
          el.style.transitionDuration = "0.2s";
          el.style.transitionTimingFunction = "cubic-bezier(0.4, 0, 1, 2)";
          el.classList.add("aos-animate");
        }
      });
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Extract image, sub-heading, and descriptions from Loop2
  const image = Loop2.find((item) => item.key === "image");
  const subHeading = Loop2.find((item) => item.key === "sub-heading");
  const descriptions = Loop2.filter((item) => item.key === "desc");

  // Find the smallest and largest description_id
  const description1 =
    descriptions.length > 0
      ? descriptions.reduce((min, desc) =>
          desc.description_id < min.description_id ? desc : min
        )
      : null;
  const description2 =
    descriptions.length > 0
      ? descriptions.reduce((max, desc) =>
          desc.description_id > max.description_id ? desc : max
        )
      : null;

  return (
    <div
      style={{
        overflowX: "hidden",
        overflowY: "hidden",
      }}
    >
      <div
        className="flex justify-between"
        data-aos="fade-right"
        data-aos-delay="500"
      >
        {/* Image 1 */}
        <div
          className="flex justify-end hidden lg:block"
          style={{ flex: 1, background: "#EBEEF3" }}
        >
          {image && (
            <img
              src={convertImagePathToUrl(subHeading.sub_heading_image)}
              alt="Team Image 1"
              className="h-full mr-auto max-h-[700px]"
            />
          )}
        </div>

        {/* Content */}
        <div
          className="h-full md:h-[700px] flex flex-col items-center"
          style={{ flex: 2, background: "#EBEEF3" }}
        >
          <div
            className="py-[10rem] mx-20 lg:mx-0"
            style={{ maxWidth: "580px" }}
          >
            {/* Sub-heading */}
            {subHeading && (
              <Typography
                className="pb-8"
                style={{
                  fontFamily: "Montserrat",
                  fontSize: 16,
                  fontWeight: 600,
                }}
              >
                {subHeading.sub_heading}
              </Typography>
            )}
            <div className="lg:hidden flex justify-center mb-6">
              <img
                src={convertImagePathToUrl(subHeading.sub_heading_image)}
                alt="Team2"
                className="w-full max-w-[480px] rounded-lg"
              />
            </div>
            <Typography
              className="pb-8"
              style={{
                fontFamily: "Montserrat",
                fontSize: 14,
                fontWeight: 500,
              }}
              dangerouslySetInnerHTML={{
                __html: formatModalDescription(subHeading.sub_heading_desc), // Correctly using dangerouslySetInnerHTML here
              }}
            />
          </div>
        </div>

        {/* Image 2 */}
        <div className="hidden lg:block" style={{ flex: 1 }}>
          {image && (
            <img
              src={GrayArrowRight}
              alt="Team Image 2"
              className="h-[700px] mr-auto leftArrowStyle"
            />
          )}
        </div>
      </div>
    </div>
  );
};
